/** @jsx jsx */
import { useRef, useState } from 'react';
import { jsx, Layout as BaseLayout, Main } from 'theme-ui';
import { Global } from '@emotion/core';
import global from '~theme/global';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { MainContainer } from '../MainContainer';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export const Layout = ({
  children
}) => {
  const {
    0: open,
    1: setOpen
  } = useState(false);
  const nav = useRef();
  return jsx(BaseLayout, {
    sx: {
      '& > div': {
        flex: '1 1 auto'
      }
    },
    "data-testid": "layout"
  }, jsx(Global, {
    styles: global
  }), jsx(Main, {
    sx: styles.main
  }, jsx(Header, {
    onOpen: () => setOpen(s => !s)
  }), jsx("div", {
    sx: styles.wrapper
  }, jsx(Sidebar, {
    ref: nav,
    open: open,
    onFocus: () => setOpen(true),
    onBlur: () => setOpen(false),
    onClick: () => setOpen(false)
  }), jsx(MainContainer, {
    "data-testid": "main-container"
  }, children))));
};

if (typeof Layout !== 'undefined' && Layout && Layout === Object(Layout) && Object.isExtensible(Layout) && !Layout.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Layout, '__filemeta', {
    configurable: true,
    value: {
      name: "Layout",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Layout/index.js"
    }
  });
}